export function formatDateID(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  } catch { return "-"; }
}

export function formatDateTimeID(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year}, ${hh}:${mm} WIB`;
  } catch { return "-"; }
}

export function formatRupiah(value) {
  if (value == null) return "Rp 0";
  const n = Number(value);
  if (isNaN(n)) return "Rp 0";
  return "Rp " + n.toLocaleString("id-ID", { maximumFractionDigits: 0 });
}

const rnd = (v) => { const n = Number(v) || 0; return Math.sign(n) * Math.round(Math.abs(n)); };
const absRp = (v) => formatRupiah(Math.abs(rnd(v)));

// Accounting style: negatif → (Rp x)
export function formatAkuntansi(value) {
  return rnd(value) < 0 ? `(${absRp(value)})` : absRp(value);
}

// Baris pengurang (HPP/beban): positif → (Rp x), negatif → Rp x
export function formatPengurang(value) {
  return rnd(value) > 0 ? `(${absRp(value)})` : absRp(value);
}
